import type { Mark } from './Text.types';

/**
 * The theme's typography lives on the leading leaf's textStyle mark, which is why an editable
 * surface mounted in a block's place has to be handed it — see EditableTextSlot.
 */
export const leadingLeafMarks = (node: { content?: unknown }) => {
  const first = Array.isArray(node.content) ? node.content[0] : undefined;
  return first && typeof first === 'object' && 'marks' in first ? (first.marks as Mark[] | undefined) : undefined;
};
